/**
 * Frontend logging utility
 *
 * In production/staging, only errors and warnings are logged.
 * In development, all log levels are enabled.
 */

const isDev = import.meta.env.MODE === 'development';

export const logger = {
  /**
   * Log informational messages (dev only)
   */
  info: (...args: any[]) => {
    if (isDev) {
      console.info(...args);
    }
  },

  /**
   * Log debug messages (dev only)
   */
  debug: (...args: any[]) => {
    if (isDev) {
      console.debug(...args);
    }
  },

  /**
   * Log general messages (dev only)
   */
  log: (...args: any[]) => {
    if (isDev) {
      console.log(...args);
    }
  },

  /**
   * Log warnings (always enabled)
   */
  warn: (...args: any[]) => {
    console.warn(...args);
  },

  /**
   * Log errors (always enabled)
   */
  error: (...args: any[]) => {
    console.error(...args);
  },
};
